import {css} from 'lit';
export const FieldcontainerSharedStyles = css`::slotted(.block-panel-element) {
    min-width: 0; /* Gives a definite min size for grid layouts */
}

::slotted(.input-field),
::slotted(keli-value),
::slotted(keli-inline-section) {
    box-sizing: border-box;
    width: 100%;
    min-height: 40px;
}

::slotted(keli-button) {
    width: max-content;
    max-width: 100%;
    min-height: 36px;
    margin: 2px 0;
}

::slotted(keli-checkbox) {
    padding-top: 7px;
}

::slotted(keli-header) {
    margin-bottom: 5px !important;
}

::slotted(keli-browse) {
    border: 1px solid var(--keli-field-border-color);
    --keli-browse-min-height: 150px;
    --keli-browse-max-height: 400px;
}

::slotted(keli-browse.focused) {
    border-color: var(--keli-field-border-color-active);
}`;

import {html} from '@polymer/polymer';
export const FieldcontainerSharedStylesHTML = html`<style>::slotted(.block-panel-element) {
    min-width: 0; /* Gives a definite min size for grid layouts */
}

::slotted(.input-field),
::slotted(keli-value),
::slotted(keli-inline-section) {
    box-sizing: border-box;
    width: 100%;
    min-height: 40px;
}

::slotted(keli-button) {
    width: max-content;
    max-width: 100%;
    min-height: 36px;
    margin: 2px 0;
}

::slotted(keli-checkbox) {
    padding-top: 7px;
}

::slotted(keli-header) {
    margin-bottom: 5px !important;
}

::slotted(keli-browse) {
    border: 1px solid var(--keli-field-border-color);
    --keli-browse-min-height: 150px;
    --keli-browse-max-height: 400px;
}

::slotted(keli-browse.focused) {
    border-color: var(--keli-field-border-color-active);
}</style>`;
